import { useEffect } from "react";

function upsert(selector, create, apply, restore) {
  let el = document.head.querySelector(selector);
  if (el) {
    const prev = apply(el, true);
    restore.push(() => prev(el));
  } else {
    el = create();
    apply(el, false);
    document.head.appendChild(el);
    restore.push(() => el.remove());
  }
}

function setMeta(attr, key, content, restore) {
  if (!content) return;
  upsert(`meta[${attr}="${key}"]`, () => { const m = document.createElement("meta"); m.setAttribute(attr, key); return m; },
    (el) => { const old = el.getAttribute("content"); el.setAttribute("content", content); return (e) => e.setAttribute("content", old); }, restore);
}

// Per-page title, description, OG/Twitter, canonical and JSON-LD; restores previous values on unmount.
export function useHead({ title, description, image, url, type = "website", jsonLd }) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    if (!title) return undefined;
    const restore = [];
    const prevTitle = document.title;
    document.title = title;
    setMeta("name", "description", description, restore);
    setMeta("property", "og:title", title, restore);
    setMeta("property", "og:description", description, restore);
    setMeta("property", "og:type", type, restore);
    setMeta("property", "og:url", url, restore);
    setMeta("property", "og:image", image, restore);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary", restore);
    setMeta("name", "twitter:title", title, restore);
    setMeta("name", "twitter:description", description, restore);
    setMeta("name", "twitter:image", image, restore);
    if (url) {
      upsert('link[rel="canonical"]', () => { const l = document.createElement("link"); l.rel = "canonical"; return l; },
        (el) => { const old = el.href; el.href = url; return (e) => { e.href = old; }; }, restore);
    }
    if (ld) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.dataset.testid = "jsonld";
      s.text = ld;
      document.head.appendChild(s);
      restore.push(() => s.remove());
    }
    return () => { document.title = prevTitle; restore.reverse().forEach((fn) => fn()); };
  }, [title, description, image, url, type, ld]);
}
